// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jGOj","icon":"styles_icon__i5Utv"};